import React, { createContext, useContext, useMemo } from 'react'

const PrivatePersonCountContext = createContext()

/**
 * @typedef {object} ReturnObj
 * @property {number|undefined} privatePersonCount
 * @property {Function} refetchPrivatePersonCount
 ** /
 
/**
 * 
 * @returns {ReturnObj}
 */

export const usePrivatePersonCountContext = () => {
  const context = useContext(PrivatePersonCountContext)
  if (!context) throw new Error('You need to use the PrivatePersonCountProvider to use usePrivatePersonCountContext')
  return context
}

/**
 *
 * @param {object} props
 * @param {number|undefined} props.privatePersonCount
 * @param {Function} props.refetchPrivatePersonCount
 * @param {import('react').ReactNode} props.children
 * @returns {JSX.Element}
 */

export default function PrivatePersonCountProvider({ privatePersonCount, refetchPrivatePersonCount, children }) {
  const value = useMemo(
    () => ({
      privatePersonCount,
      refetchPrivatePersonCount,
    }),
    [privatePersonCount, refetchPrivatePersonCount]
  )

  return <PrivatePersonCountContext.Provider value={value}>{children}</PrivatePersonCountContext.Provider>
}
